import { MODULE_NAME as CAMPAIGNS_MODULE } from 'modules/campaigns/config/routes/module';
import { FEATURE_FLAGS } from 'modules/taboola-common-frontend-modules/account-configurations';
import { FormattedMessage } from '../../../../../../taboola-common-frontend-modules/i18n';
import { isSponsoredAccountAndDimension } from '../../../../../config/report-predicates/isSponsoredAccountAndDimension';
import { REPORT_PERMISSION } from '../../../../../config/reportPermissions';
import { TOP_RESULTS_TYPE } from '../../../../../constants';
import { getIsDemographicsAudiencesEnabled } from '../../../../../services/utils/audiences/getIsDemographicsAudiencesEnabled';
import { BULK_ACTION } from '../../../components/BulkActionToolbar/bulkAction';
import {
    CONVERSIONS,
    IMPRESSIONS_PCT,
    CONVERSIONS_CLICKS,
    CONVERSIONS_VIEWS,
    CVR,
    AVERAGE_CPC,
    CVR_CLICKS,
    CVR_VIEWS,
    AUDIENCE_NAME,
    ID,
} from '../../fields';
import { FILTER_TYPE } from '../../filters';
import { REPORT_PRESET } from '../../pickers';
import { generateBulkActionsOnDuplicateHandler } from '../audience-insights/generateBulkActionsOnDuplicateHandler';
import { AUDIENCE_INSIGHTS_DEMOGRAPHICS_REPORT_ID } from './audienceInsightsDemographicsReportId';
import columnDefinitions from './columnDefinitions';
import graph from './graph';
import { customColumns, defaultColumns } from './reportPresets';

export const audiencesInsightsDemographicsReportConfig = {
    id: AUDIENCE_INSIGHTS_DEMOGRAPHICS_REPORT_ID,
    label: 'Audiences Demographics (Beta)',
    accountConfigurations: {
        [FEATURE_FLAGS.ONLY_PERFORMANCE_REPORTS]: 'false',
        [FEATURE_FLAGS.CAN_EDIT_CAMPAIGN_USER_SEGMENTS]: 'true',
    },
    permissions: [REPORT_PERMISSION.ADS_CONSOLE_AUDIENCE_REPORT],
    visibilityCondition: conf => {
        const {
            configs: { selectedAccountConfig },
        } = conf;
        return isSponsoredAccountAndDimension(conf) && getIsDemographicsAudiencesEnabled(selectedAccountConfig);
    },
    module: CAMPAIGNS_MODULE,
    endpoint: 'campaign-report-by-audience-insights-demographics',
    graph,
    rowIdField: ID.field,
    columnsDef: columnDefinitions,
    presets: {
        [REPORT_PRESET.DEFAULT]: { columns: defaultColumns },
    },
    customPreset: { columns: customColumns, initialState: defaultColumns },
    footerColumnDef: [],
    isEmptyFooter: true,
    searchPlaceholderMsgId: 'app.reports.byAudience.search.placeholder',
    searchField: AUDIENCE_NAME.field,
    sortMap: {
        [CONVERSIONS.field]: 'cpaActionsNum',
        [IMPRESSIONS_PCT.field]: 'impressionsPct',
        [CONVERSIONS_CLICKS.field]: 'cpaActionsNumFromClicks',
        [CONVERSIONS_VIEWS.field]: 'cpaActionsNumFromViews',
        [CVR.field]: 'cpaConversionRate',
        [AVERAGE_CPC.field]: 'cpc',
        [CVR_CLICKS.field]: 'cpaConversionRateClicks',
        [CVR_VIEWS.field]: 'cpaConversionRateViews',
    },
    bulkActions: [
        {
            key: BULK_ACTION.DUPLICATE,
            handler: generateBulkActionsOnDuplicateHandler,
            buttonContent: (
                <FormattedMessage
                    id="app.campaigns.reports.bulkAction.toolbar.duplicate.audience"
                    defaultMessage="Duplicate Campaign Using Audiences"
                />
            ),
        },
    ],
    filters: [
        {
            id: FILTER_TYPE.TOP_RESULTS,
            permissions: ['ADS_CONSOLE_ACCOUNTS_FILTERS'],
        },
        { id: FILTER_TYPE.DEMOGRAPHIC_GROUP, multiSelect: true, minVisibleCount: 4 },
    ],
    initialFilters: [
        {
            id: FILTER_TYPE.TOP_RESULTS,
            type: FILTER_TYPE.TOP_RESULTS,
            values: [{ value: TOP_RESULTS_TYPE.TOP200, label: 'Top 200', messageId: 'report.topResults.200' }],
            accountConfigurations: { [FEATURE_FLAGS.REPORT_AUTO_FILTERS]: 'true' },
        },
    ],
};

export default audiencesInsightsDemographicsReportConfig;
